// extracted by mini-css-extract-plugin
export default {"joinAProject":"style_joinAProject__OIPg3"};